import { QRCodeSVG } from "qrcode.react";

interface QRCodeProps {
  barcode: string;
}

export const QRCodeComponent = ({ barcode }: QRCodeProps) => {
  return <QRCodeSVG value={barcode} size={180} level="M" fgColor="#000000" bgColor="#ffffff" />;
};
